import Backbone from 'backbone'
import serversTemplate from './admin-ldap-servers.hbs'
import formHelper from 'scoreboard/components/form-helper'
import appDisplay from 'scoreboard/components/app-display'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/**
 *
 * @property {LdapServers} model Backbone.Collection
 */
var LdapServersView = Backbone.View.extend({
	className: 'ldap-servers',

	events: {
		'click .add-server': 'add'
	},

	render: function () {
		this.$el.html(serversTemplate())

		this._serverViews = []
		this.model.forEach(this._renderServer.bind(this))

		this.model.on('add', function (newServer) {
			var newView = this._renderServer(newServer)
			newView.scrollTo()
		}.bind(this))

		// Needed when a save happens to properly hide the no ldap servers message
		// triggered by `this.ldapServers.set` in admin-app.js
		this.model.on('update', () => this.toggleServers())

		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		this.toggleServers()

		return this
	},

	_renderServer: function (server) {
		var serverView = new LdapServerView({ model: server })
		this._serverViews.push(serverView)

		this.$('ul.list').append(serverView.el)
		serverView.render()

		server.on('remove', function () {
			serverView.remove()
			_.remove(this._serverViews, function (v) { return v === serverView })
			this.toggleServers()
		}.bind(this))

		return serverView
	},

	add: function () {
		var server = new LdapServer()
		var editView = new EditLdapServer({model: server})

		appDisplay.dialog(editView)

		editView.on('done', function () {
			server.set('message', i18n.get('admin.authentication.ldap.saveToCheckStatus'))
			this.model.add(server)
			this.toggleServers()
		}.bind(this))

	},

	toggleServers() {
		this.$('.no-servers').toggleClass('is-not-displayed', !this.model.isEmpty())
	},

	scrollTo: function () {
		this.el.scrollIntoView(false)
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this._serverViews, 'remove')
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}

})

import serverTemplate from './admin-ldap-server.hbs'
import LdapServer from './ldap-server-model'
import $ from 'jquery'
import ErrorView from 'scoreboard/components/error-view'

var LdapServerView = Backbone.View.extend({
	className: 'ldap-server',
	tagName: 'li',

	events: {
		'click .edit': 'edit',
		'click .delete': 'delete',
		'click .error-details': 'showError',
		'click': 'toggleStatus'
	},

	render: function () {
		this.$el.html(serverTemplate(this.model.toJSON()))

		this.listenTo(this.model, 'change:url change:message', this.updateStatusMessages.bind(this))
		this.listenTo(this.model, 'change:online', this.updateOnline.bind(this))

		this.updateStatusMessages()
		this.updateOnline()

		return this
	},

	edit: function () {
		var editedServer = new LdapServer(this.model.toJSON())
		var editView = new EditLdapServer({model: editedServer})

		appDisplay.dialog(editView)

		editView.on('done', function () {
			this.model.set(_.extend(
				editedServer.toJSON(),
				// clear out old status info; it will be updated when full config is saved
				{
					message: i18n.get('admin.authentication.ldap.saveToCheckStatus'),
					stackTrace: null,
					online: null
				}))

			// won't know if it's online or offline until config is saved
			this.$el.removeClass('online').removeClass('offline')
		}.bind(this))
	},

	delete: function () {
		this.model.collection.remove(this.model)
	},

	showError: function () {
		appDisplay.dialog(new ErrorView(this.model.toJSON()))
	},

	toggleStatus: function (e) {
		if ($(e.target).closest('.list-item-actions, .error-details').length > 0) {
			return
		}

		this.$el.toggleClass('message-displayed')
		this.scrollTo()
	},

	updateStatusMessages: function () {
		this.$('.label').text(this.model.get('url'))

		this.$('.error-message')
			.text(this.model.get('message'))

		this.$('.error-details').toggleClass('is-not-displayed', !this.model.get('stackTrace'))
	},

	updateOnline: function () {
		this.$el
			.toggleClass('online', this.model.get('online') === true)
			.toggleClass('offline', this.model.get('online') === false)
	},

	scrollTo: function () {
		this.el.scrollIntoView(false)
	}
})

import editTemplate from './edit-ldap-server.hbs'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import FormView from 'scoreboard/components/form-view'

var EditLdapServer = Backbone.View.extend({
	className: 'edit-ldap-server',
	tagName: 'form',

	render: function () {
		this.$el.html(editTemplate(this.model.toJSON()))

		this._markedFields = ['url', 'baseDn', 'adminDn', 'adminPassword', 'userFilter'].map(function (field) {
			return new MarkedField({
				el: this.$('[name=' + field + ']'),
				validator: requiredValidator
			}).render()
		}.bind(this))

		formHelper.writeToDom(this.model.toJSON(), this.el)

		this.formView = new FormView( { el: this.el, submit: this.done.bind(this) })
		this.formView.start()

		return this
	},

	done: function () {
		this.model.set(formHelper.readFromDom(this.el))
		this.trigger('done')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this._markedFields, 'remove')
		_.invokeMap([this.formView, this.covertButtonTooltips], 'remove')
	}
})

export default LdapServersView

LdapServersView.__filename__ = 'admin/configuration/admin-ldap-servers.js'
